/* eslint-disable */
/* TODO: If you edit this file remove eslint-disable and fix linting errors in this file. */
require('../../core/scripts/voice/voice.module');
require('../../core/scripts/voice/voice.api');
require('../../core/scripts/voice/voice.service');
require('../../core/scripts/voice/voiceCallerIdDisplay.directive');
require('../../core/scripts/voice/voiceCallButton.directive');
require('../../core/scripts/voice/voiceCallStatus.filter');
require('../../core/scripts/voice/voiceCallLength.filter');
